import { z } from 'zod';
import type { GalleryFilters, GalleryGroupBy, GallerySort, GalleryView } from './galleryFilters';

// URL sửa tay sai → coi như không có tham số. Giá trị MẶC ĐỊNH (view=group, sort=sheet, status=all, group=phase)
// không nằm trong kiểu nên không thể xuất hiện trên URL (rule 10).
const lenientStr = z.unknown().transform((v) => {
  const t = typeof v === 'number' && Number.isFinite(v) ? String(v) : v; // router parse JSON: ?q=2025 đến dạng số
  return typeof t === 'string' && t.trim() ? t : undefined;
}).optional();
const lenientEnum = <T extends string>(values: readonly T[]) =>
  z.unknown().transform((v) => (typeof v === 'string' && (values as readonly string[]).includes(v) ? (v as T) : undefined)).optional();

export const gallerySearchSchema = z.object({
  q: lenientStr,
  khoi: lenientStr,
  status: lenientEnum(['on', 'off'] as const),
  lead: lenientStr,
  sort: lenientEnum(['prog', 'sev'] as const),
  view: lenientEnum(['grid', 'tiendo', 'kanban'] as const),
  group: lenientEnum(['lead'] as const),
});
export type GallerySearch = z.output<typeof gallerySearchSchema>;
export type SearchPatch = Partial<Record<keyof GallerySearch, string | undefined>>;

const DEFAULTS: Partial<Record<keyof GallerySearch, string>> = { status: 'all', sort: 'sheet', view: 'group', group: 'phase' };

export const toFilters = (s: GallerySearch): GalleryFilters => ({
  q: s.q ?? '', status: s.status ?? 'all', khoi: s.khoi ?? null, lead: s.lead ?? null,
});
export const viewOf = (s: GallerySearch): GalleryView => s.view ?? 'group';
export const sortOf = (s: GallerySearch): GallerySort => s.sort ?? 'sheet';
export const groupOf = (s: GallerySearch): GalleryGroupBy => s.group ?? 'phase';

/** Áp một bản vá; khoá rỗng hoặc bằng mặc định bị bỏ. */
export function patchSearch(s: GallerySearch, patch: SearchPatch): GallerySearch {
  const merged: Record<string, string | undefined> = { ...s, ...patch };
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(merged)) {
    if (v === undefined || v.trim() === '' || DEFAULTS[k as keyof GallerySearch] === v) continue;
    out[k] = v;
  }
  return out as GallerySearch;
}

/** Chỉ q / khối / trạng thái / chủ trì là "lọc"; kiểu xem, sắp xếp, nhóm thì không. */
export const isFiltered = (s: GallerySearch): boolean => !!(s.q || s.khoi || s.status || s.lead);
